import css from 'styled-jsx/css';

import { medium, large, extraLarge } from 'constants/mediaQueries';
import Theme from 'styles/theme';

export default css`
  .typography--brand-heading {
    font-weight: ${Theme.get('font-weight-semi-bold')};
    font-style: ${Theme.get('font-style-oblique')};
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    color: ${Theme.get('colors-white')};
    text-align: center;
    font-size: 27px;
    line-height: 1.4;
    letter-spacing: 4px;
  }

  @media ${medium} {
    .typography--brand-heading {
      font-size: 48px;
      letter-spacing: 6px;
    }
  }

  @media ${large} {
    .typography--brand-heading {
      font-size: 55px;
      letter-spacing: 8px;
    }
  }

  @media ${extraLarge} {
    .typography--brand-heading {
      font-size: 72px;
      letter-spacing: 10px;
    }
  }
`;
